import { Tooltip } from '@airbus/components-react';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';

export type InfoTooltipProps = {
  label: string;
  className?: string;
  placement?: 'top' | 'right' | 'bottom' | 'left';
  iconSize?: 'inherit' | 'small' | 'medium' | 'large';
};

export default function InfoTooltip({
  label,
  className,
  placement = 'right',
  iconSize = 'small',
}: InfoTooltipProps) {
  return (
    <Tooltip label={label} className={className} placement={placement}>
      <InfoOutlineIcon fontSize={iconSize} />
    </Tooltip>
  );
}
